import { render, staticRenderFns } from "./EventOrganizerAdmin.vue?vue&type=template&id=3f295a61"
import script from "./EventOrganizerAdmin.vue?vue&type=script&lang=js"
export * from "./EventOrganizerAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports